import { render, staticRenderFns } from "./DeliveryPriceBaseOnLocation.vue?vue&type=template&id=ef3358ce&scoped=true"
import script from "./DeliveryPriceBaseOnLocation.vue?vue&type=script&lang=js"
export * from "./DeliveryPriceBaseOnLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3358ce",
  null
  
)

export default component.exports